/**
 * Pushes named events to window.dataLayer for every meaningful user action,
 * so GTM tags/triggers can key off event names (add_to_cart, begin_checkout,
 * video_progress, etc). Requires constants.js + pubsub.js to load first.
 */
(function () {
  'use strict';

  function pushEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined;

  // --- Add to cart / cart errors -------------------------------------------------
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;
      var item = event.cartData || {};
      var price = typeof item.price === 'number' ? item.price / 100 : undefined;
      pushEvent('add_to_cart', {
        ecommerce: {
          currency: currency,
          value: price !== undefined ? price * (item.quantity || 1) : undefined,
          items: [
            {
              item_id: item.variant_id,
              item_name: item.product_title || item.title,
              item_variant: item.variant_title,
              price: price,
              quantity: item.quantity,
            },
          ],
        },
      });
    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      pushEvent('add_to_cart_error', {
        error_message: event.error || event.code || 'unknown_error',
      });
    });
  }

  // --- Cart line remove / quantity change -----------------------------------------
  document.addEventListener(
    'click',
    function (e) {
      var removeEl = e.target.closest('cart-remove-button, [data-cart-remove], a.cart-remove, button.cart-remove');
      if (removeEl) {
        var row = removeEl.closest('[data-variant-id], .cart-item, tr');
        pushEvent('remove_from_cart', {
          variant_id: row ? row.getAttribute('data-variant-id') : undefined,
        });
      }
    },
    true
  );

  // --- Begin checkout ---------------------------------------------------------------
  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest(
        'button[name="checkout"], a[href*="/checkout"], input[name="checkout"]'
      );
      if (el) {
        pushEvent('begin_checkout', {
          ecommerce: { currency: currency },
        });
      }
    },
    true
  );

  // --- Newsletter + contact form submits --------------------------------------------
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      // form.id/.action can be shadowed by a same-named form control
      // (e.g. a hidden <input name="id"> in cart line-item forms), so
      // always read the real attribute instead of the DOM property.
      var formId = form.getAttribute('id') || '';
      var formAction = form.getAttribute('action') || '';

      if (formId === 'ContactForm') {
        pushEvent('contact_form_submit', { form_id: formId });
        return;
      }

      var isNewsletter =
        formId.indexOf('NewsletterForm') !== -1 ||
        form.querySelector('input[name="contact[tags]"]');
      if (isNewsletter) {
        var emailField = form.querySelector('input[type="email"]');
        pushEvent('newsletter_signup', {
          form_id: formId,
          email_domain: emailField && emailField.value.indexOf('@') !== -1
            ? emailField.value.split('@')[1]
            : undefined,
        });
        return;
      }

      if (formAction.indexOf('/search') !== -1) {
        var q = form.querySelector('input[name="q"]');
        pushEvent('search', { search_term: q ? q.value : '' });
      }
    },
    true
  );

  // --- Video view + watch-time tracking ---------------------------------------------
  var MILESTONES = [10, 25, 50, 75, 90, 100];

  function trackVideo(video) {
    if (video.dataset.slvTracked) return;
    video.dataset.slvTracked = '1';

    var fired = {};
    var watchedSeconds = 0;
    var lastTime = 0;
    var playing = false;
    var started = false;

    function accumulate() {
      if (playing) {
        watchedSeconds += Math.max(0, video.currentTime - lastTime);
        lastTime = video.currentTime;
      }
    }

    function videoSrc() {
      return video.currentSrc || video.src || video.dataset.mediaId || '';
    }

    video.addEventListener('play', function () {
      playing = true;
      lastTime = video.currentTime;
      if (!started) {
        started = true;
        pushEvent('video_start', { video_src: videoSrc() });
      }
    });

    video.addEventListener('pause', function () {
      accumulate();
      playing = false;
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      var pct = Math.floor((video.currentTime / video.duration) * 100);
      MILESTONES.forEach(function (m) {
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          accumulate();
          pushEvent('video_progress', {
            video_src: videoSrc(),
            percent_played: m,
            watch_time_seconds: Math.round(watchedSeconds),
          });
        }
      });
    });

    video.addEventListener('ended', function () {
      accumulate();
      pushEvent('video_complete', {
        video_src: videoSrc(),
        watch_time_seconds: Math.round(watchedSeconds),
      });
    });

    function reportFinalWatchTime() {
      accumulate();
      if (watchedSeconds > 0) {
        pushEvent('video_watch_time', {
          video_src: videoSrc(),
          watch_time_seconds: Math.round(watchedSeconds),
        });
      }
    }

    window.addEventListener('pagehide', reportFinalWatchTime);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') reportFinalWatchTime();
    });
  }

  function scanVideos() {
    document.querySelectorAll('video').forEach(trackVideo);
  }

  scanVideos();
  new MutationObserver(scanVideos).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
